import { render, staticRenderFns } from "./lkuReceiving.vue?vue&type=template&id=5452abb9"
import script from "./lkuReceiving.vue?vue&type=script&lang=js"
export * from "./lkuReceiving.vue?vue&type=script&lang=js"
import style0 from "./lkuReceiving.vue?vue&type=style&index=0&id=5452abb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports